import * as VueGoogleMaps from 'vue2-google-maps/dist/vue-google-maps.js'
// import gmapCluster from 'vue2-google-maps/dist/components/cluster'

import mapStyles from './imports/map-styles'

export default {
  components: {
    // gmapCluster,
    googleMap: VueGoogleMaps.Map,
    googleMarker: VueGoogleMaps.Marker,
    googleInfoWindow: VueGoogleMaps.InfoWindow
  },
  data() {
    return {
      mapCenter: {
        lat: 37.719343,
        lng: 23.9133373
      },
      mapOpts: {
        styles: mapStyles,
        // gestureHandling: "greedy",
        streetViewControl: false,
        mapTypeControl: false,
        zoomControl: true,
        fullscreenControl: false,
        scrollwheel: false,
        // mapTypeId: 'satellite'
      },
      mapIcon: {
        url: '/public/site/' + process.env.MIX_TEMPLATE_FOLDER + '/dist/images/pin.svg',
        // size: {width: 46, height: 46, f: 'px', b: 'px'},
        scaledSize: {
          width: 25,
          height: 27,
          f: 'px',
          b: 'px'
        }
      },
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -30
        }
      },
      infoContent: {
        title: null,
        descr: null,
        address: null
      },
      infoWindowPos: null,
      currentMidx: null,
      clusterStyles: [{
        textColor: '#fff',
        url: '/public/site/' + process.env.MIX_TEMPLATE_FOLDER + '/dist/img/cluster.png',
        height: 50,
        width: 50
      }]
    }
  },
  methods: {
    toggleInfoWindow: function (position, content, idx) {

      this.infoWindowPos = position;
      this.infoContent = content

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
}